export default "__VITE_ASSET__D_D3161u__"